/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { ITitolario } from "../shared/interfaces";

const controller = 'FilingPlan';



const getFilingPlan = (aooId: number, cancelToken?: CancelToken): Promise<ITitolario[]> => {
    return axiosInstance.get(`${controller}/${aooId}/Get`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const addFilingPlanNode = (aooId: number, filingPlanNode: Partial<ITitolario>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/Add`, filingPlanNode, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const deleteFilingPlanNode = (aooId: number, id: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/Delete/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const updateFilingPlanNode = (aooId: number, id: number, filingPlanNode: Partial<ITitolario>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/Update/${id}`, filingPlanNode, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getFilingPlan,
    addFilingPlanNode,
    deleteFilingPlanNode,
    updateFilingPlanNode
}